//registry
import moduleRegistry from '@/configuration/module-registry.js';
//store
import store from '@/store';

export default {
  findModuleWithLink(link) {
    if (link == null) return null;
    var modules = moduleRegistry.tree;

    for (let m in modules) {
      for (let c in modules[m].children) {
        var child = modules[m].children[c];
        if (child.routerLink != null) {
          var linkRegex = new RegExp('^(\/)*' + link + '(\/.*)*$', 'g');//eslint-disable-line
          if (linkRegex.test(child.routerLink)) return modules[m];
        }
      }
    }
    return null;
  },
  isLinkAllowed(link) {
    if (link == null) return true;

    const regIdAtEnd = /\/\d*$/;
    link = link.replace(regIdAtEnd, ''); //remove id at end

    var module = this.findModuleWithLink(link);
    if (module == null) return true;

    let childLink = null;
    let children = module.children != null ? module.children : [];
    for (let c in children) {
      var child = children[c];
      if (child.routerLink != null) {
        var linkRegex = new RegExp('(/)*' + link + '(.)*', 'g');
        if (linkRegex.test(child.routerLink)) {
          childLink = child;
        }
      }
    }
    //check
    if (childLink != null && childLink.neverHide) return true;

    if (module.id == null) return true;
    return store.getters['actingUser/isUserAllowedToSeeModule'](
      module.id
    ) || store.getters['actingUser/isUserAllowedToSeeModule'](
      link?.slice(1)
    );
  },
  icon(msgLink) {
    // the icon depends on the link in the message and the icon in the moduleRegistry.tree
    var defaultIcon = '$wEmail';
    if (msgLink == null) return defaultIcon;

    const regIdAtEnd = /\/\d*$/;
    msgLink = msgLink.replace(regIdAtEnd, ''); //remove id at end

    var module = this.findModuleWithLink(msgLink);
    return module == null || module.icon == null ? defaultIcon : module.icon;
  },
  moduleLinkName(message) {
    if (message.data.moduleLinkName != null)
      return message.data.moduleLinkName;

    let parts = message.data.messageParts;
    if (
      parts == null ||
      parts.data.length <= 0 ||
      parts.data[0].data.moduleLinkName == null
    )
      return undefined;
    else return parts.data[0].data.moduleLinkName;
  },
  moduleLink(message) {
    let linkInMsg = this.findLinkInMessage(message);
    if (linkInMsg == null) return null;

    let hasSlashAtBeginning = /^\/(.)*/.test(linkInMsg);
    if (!hasSlashAtBeginning) linkInMsg = '/' + linkInMsg;

    let hasSlashAtEnd = /\/$/.test(linkInMsg);
    return hasSlashAtEnd ? linkInMsg + message.id : linkInMsg;
  },
  moduleLinkForOverviewItem(item) {
    let linkInMsg = item.moduleLink;
    if (!linkInMsg) return;
    let hasSlashAtBeginning = /^\/(.)*/.test(linkInMsg);
    if (!hasSlashAtBeginning) linkInMsg = '/' + linkInMsg;

    let hasSlashAtEnd = /\/$/.test(linkInMsg);
    return hasSlashAtEnd ? linkInMsg + item.id : linkInMsg;
  },
  findLinkInMessage(message) {
    if (message?.data?.moduleLink != null)
      return message?.data?.moduleLink;

    let parts = message?.data?.messageParts;
    if (
      parts == null ||
      parts.data.length <= 0 ||
      parts.data[0].data.moduleLink == null
    )
      return null;
    else {
      return parts.data[0].data.moduleLink;
    }
  },

}
